
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import Swal from "sweetalert2";
import CityResponse from "@/models/WsdlResponses/CityResponse";
import ZoneResponse from "@/models/WsdlResponses/ZoneResponse";
import OccupationResponse from "@/models/WsdlResponses/OccupationResponse";
import TypeResponse from "@/models/WsdlResponses/TypeResponse";

@Component({})
export default class SolicitudReclamacionesResult extends Vue {
    public email: string = this.$store.state.user.correoElectronico1;
    public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    public userId: string = this.$store.state.user.cedula;

    public async mounted() {
        // await this.getCities;
    }

    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
}
